import { render } from "./KeyIcon.vue?vue&type=template&id=6b5486d9"
import script from "./KeyIcon.vue?vue&type=script&lang=js"
export * from "./KeyIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__